import { config } from "../../Config";

async function getExtensionsByUserId(userId) {
    const functionUrl = config.getExtensionsByUserId;
    try {
        const response = await fetch(functionUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ userId }),
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(
                `Failed to fetch extensions: ${response.status} ${response.statusText} - ${errorText}`
            );
        }

        const extensions = await response.json();
        return extensions;
    } catch (error) {
        // console.error("Error fetching user extensions:", error);
        throw error;
    }
}

export default getExtensionsByUserId;
